import { parse, stringify } from 'hub-http/helpers/params';
export const parseQueryParams = queryString => {
  const queryParams = parse(queryString.replace('?', ''));
  Object.keys(queryParams).forEach(key => {
    const value = queryParams[key];
    let adaptedValue;
    try {
      /*
      This is the case when multiple values for the same queryParam key are passed in.
      For example
        parse(products=marketing-hub-professional_1&products=core-seats-professional_0&term=annual)
      returns
        {
          products: ['marketing-hub-professional_1', 'core-seats-professional_0'],
          term: 'annual'
        }
        While
          parse(products=marketing-hub-professional_1&term=annual)
        returns
        {
          products: 'marketing-hub-professional_1',
          term: 'annual'
        }
      */
      if (Array.isArray(value)) {
        adaptedValue = value.map(val => JSON.parse(val));
      } else {
        adaptedValue = JSON.parse(value);
      }
    } catch (e) {
      adaptedValue = value;
    }
    queryParams[key] = adaptedValue;
  });
  return queryParams;
};
export const getQueryParams = () => parseQueryParams(window.location.search);
export const getSavedQueryParams = (queryParams, paramsToSave) => {
  const savedQueryParams = {};
  const defaultParamsToSave = '^hubs_|^utm_';
  const expression = paramsToSave && paramsToSave.length ? `${defaultParamsToSave}|${paramsToSave.join('|')}` : defaultParamsToSave;
  const re = new RegExp(expression);
  Object.keys(queryParams).forEach(param => {
    const match = param.match(re);
    if (match && !(param === 'hubs_signup-url' || param === 'hubs_signup-cta')) {
      savedQueryParams[param] = queryParams[param];
    }
  });
  return savedQueryParams;
};
export const stringifyQueryParams = queryParams => {
  // Drop empty params to keep the query string clean, but preserve meaningful
  // falsy values like 0 and false (e.g. ?credits=0 must survive).
  Object.keys(queryParams).forEach(key => {
    const value = queryParams[key];
    if (value === undefined || value === null || value === '') {
      delete queryParams[key];
    }
  });
  return stringify(queryParams);
};
export const getSavedQueryParamString = paramsToSave => {
  const queryParams = getQueryParams();
  const savedQueryParams = getSavedQueryParams(queryParams, paramsToSave);
  return stringifyQueryParams(savedQueryParams);
};
export const createToObject = pathname => {
  const search = getSavedQueryParamString(['upgradeSource', 'show-tts-chat', 'forceSeatsPricing', 'isHsoc', 'overrideLocale', 'currencyCode', 'purchaseFailedProduct']);
  return {
    pathname,
    search
  };
};
export const getRedirectQueryParamsForCheckout = () => {
  const paramsToSave = ['dtb_source', 'hubs_content', 'hubs_content-cta', 'hubs_signup-url', 'hubs_signup-cta'];
  const queryParams = getQueryParams();
  const redirectQueryParams = {};
  for (const param of paramsToSave) {
    if (queryParams[param]) {
      const value = queryParams[param];
      if (value !== undefined) {
        redirectQueryParams[param] = Array.isArray(value) ? value[0] : value;
      }
    }
  }
  return redirectQueryParams;
};